import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

const languages = [
  { code: "en", name: "EN" },
  { code: "ar", name: "AR" },
];
const LanguageSelector = ({ reloadOnLanguageChange = false }) => {
  const { i18n } = useTranslation();
  const hostName = window.location.hostname;
  const isLebara = hostName === "lebara.gamerclub.live";
  const isMtnza = hostName.includes("mtnza");
  const currentLang = i18n.language?.startsWith("ar") ? "ar" : "en";

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    if (isLebara || reloadOnLanguageChange) {
      window.location.reload();
    }
  };
  useEffect(() => {
    if (isMtnza) {
      document.body.dir = "ltr";
      return;
    }
    document.body.dir = i18n.dir();
  }, [i18n, i18n.language, isMtnza]);

  if (isMtnza) {
    return null;
  }

  return (
    <div className="language-switcher">
      <select
        onChange={(e) => changeLanguage(e.target.value)}
        value={currentLang}
        className="language-selector"
      >
        {languages.map((language, index) => (
          <option
            key={index}
            // selected={language.code === i18n.language ? true : false}
            value={language.code}
          >
            {language.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSelector;
